import { CALL, GET_ID_USER } from "./endpoint";
import schoolClient from "./school-axios-client";

const ProfileService = {
  getIdUser: async () => {
    return schoolClient.get(GET_ID_USER);
  }
};
export default ProfileService;
